import { render, staticRenderFns } from "./agency-auth-manage.vue?vue&type=template&id=61f78df8&scoped=true"
import script from "./agency-auth-manage.vue?vue&type=script&lang=js"
export * from "./agency-auth-manage.vue?vue&type=script&lang=js"
import style0 from "./agency-auth-manage.vue?vue&type=style&index=0&id=61f78df8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f78df8",
  null
  
)

export default component.exports